import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3f661bfd&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3f661bfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f661bfd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f661bfd')) {
      api.createRecord('3f661bfd', component.options)
    } else {
      api.reload('3f661bfd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3f661bfd&scoped=true&", function () {
      api.rerender('3f661bfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PlatformDataExcel/index.vue"
export default component.exports